module.exports = __webpack_public_path__ + "img/liquid_sink.23ca1d5c.svg";